// extracted by mini-css-extract-plugin
export default {"footer":"GlobalFooter_footer__p77fK","content":"GlobalFooter_content__2P9P-","copy":"GlobalFooter_copy__im++b"};